import React from "react";
import PropTypes from "prop-types";

const ToolTip = ({ message, showAbove }) => {
    return (
        <div
            className={`ToolTip ${
                showAbove ? "above" : "below"
            }`}
        >
            {message}
        </div>
    );
};

ToolTip.propTypes = {
    message: PropTypes.string.isRequired,
    showAbove: PropTypes.bool, // Determines position
};

ToolTip.defaultProps = {
    showAbove: false, // Default is below
};

export default ToolTip;
